/**
 * Store keys for images
 * @module services/images
 */

/**
  * The images store key
  */
export const STORE_KEY_IMAGES = 'images'
